import Vue from 'vue'
import Vuex from 'vuex'

import background_actions from './background_actions'
import app from './app'
import core from './core'
import operation from './operation'
import cdp from './cdp'
import content from './content'
import node from './node'
import ai_workforce from './ai_workforce'
import job from './job'

Vue.use(Vuex)

const store = {
  modules: {
  background_actions,
  app,
  core,
  operation,
  cdp,
  content,
  node,
  ai_workforce,
  job,
  }
}

const vuexStore = new Vuex.Store(store)

window.addEventListener('storage', event => {
  if (event.key === 'token' && event.newValue) {
    vuexStore.dispatch('core/auth/syncStoredToken')
  }
})

export default vuexStore
